// The Digital Philosophy mark: an aperture — two rings framing two bars.
// Kept as one source of truth so every rendering (header, intro, footer) is
// pixel-identical and the intro "draw-on" can reference exact path lengths.
export const APERTURE = {
  viewBox: "0 0 600 500",
  rings: [
    { cx: 159, cy: 249.5, r: 46 },
    { cx: 435, cy: 249.5, r: 46 },
  ],
  bars: [
    { x: 266, y1: 67, y2: 310 },
    { x: 327.5, y1: 189, y2: 432 },
  ],
};

// Stroke path lengths, used as stroke-dasharray for the intro draw-on animation.
// (Circumference 2πr with r=46; bars are 310−67 === 432−189.)
export const RING_LEN = Number((2 * Math.PI * 46).toFixed(2)); // 289.03
export const BAR_LEN = 243;
